import React from 'react';
import { SearchOutlined, FilterOutlined } from '@ant-design/icons';
import { Container } from '@/components/ui/Container';
import Table from '@/components/ui/table/Table';
import { SliderTab } from '@/components/ui/SliderTab';
import { usePermissionsPage } from '@hooks/rbac/usePermissionsPage';
import ListBodyLayout from '@/components/layout/ListBodyLayout';
import {
    RolesSliderTabWrap,
    RolesSearchWrapper,
    RolesSearchInput,
    RolesFilterBtn,
} from './style';

const Permissions = () => {
    const {
        searchText,
        setSearchText,
        activeTab,
        setActiveTab,
        sliderTabItems,
        tableData,
        columns,
        permissions,
        uniqueModules,
        uniqueFeaturesCount,
        uniqueActionsCount,
    } = usePermissionsPage();

    return (
        <ListBodyLayout
            title="Permissions"
            description="Manage permissions of your company"
            kpiCards={[
                {
                    title: 'Total Permissions',
                    value: permissions.length,
                    change: { value: '', isPositive: true, text: 'in workspace' },
                },
                {
                    title: 'Modules',
                    value: uniqueModules.length,
                    change: { value: '', isPositive: true, text: 'Unique modules' },
                },
                {
                    title: 'Features',
                    value: uniqueFeaturesCount,
                    change: { value: '', isPositive: true, text: 'Unique features' },
                },
                {
                    title: 'Actions',
                    value: uniqueActionsCount,
                    change: { value: '', isPositive: true, text: 'Unique actions' },
                },
            ]}
        >
            <Container
                $display="flex"
                $justifyContent="space-between"
                $alignItems="center"
                $flexWrap="wrap"
                $gap="12px"
                $marginBottom="16px"
            >
                <Container $display="flex" $alignItems="center" $minWidth="0">
                    <RolesSliderTabWrap>
                        <SliderTab items={sliderTabItems} activeKey={activeTab} onChange={setActiveTab} fitContent />
                    </RolesSliderTabWrap>
                </Container>
                <Container $display="flex" $alignItems="center" $gap="10px">
                    <RolesSearchWrapper>
                        <SearchOutlined />
                        <RolesSearchInput
                            placeholder="Search here"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </RolesSearchWrapper>
                    <RolesFilterBtn type="button">
                        <FilterOutlined />
                        Filter
                    </RolesFilterBtn>
                </Container>
            </Container>

            <Table
                title=""
                columns={columns}
                dataSource={tableData}
                searchValue={searchText}
                onSearchChange={setSearchText}
                showSearch={false}
                showFilter={false}
                showMore={false}
                hideToolbar
                pagination
                pageSize={10}
                $topMargin={false}
                $radius={12}
            />
        </ListBodyLayout>
    );
};

export default Permissions;
